import React from "react";
import styled from "styled-components";
import Card from "../Card";
import Tooltip from "./Tooltip";
import GameRule from "../Types/GameRule";

const CardContainer = styled.div`
  font-size: 5vw;
  display: flex;
  justify-content: center;
  padding-bottom: 3rem;
`;

const BombTooltip = () => (
  <Tooltip>
    <h1>Bomb mode</h1>
    <h4>In bomb mode some cards will be bomb cards.</h4>
    <p>
      Bomb cards means that either you or the player after you needs to cover it
      immediately otherwise you instantly loose!
    </p>
    <CardContainer>
      <Card gameRule={GameRule.Bomb} number={22} gameId={0}>
        13
      </Card>
    </CardContainer>
  </Tooltip>
);

export default BombTooltip;
